import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

export const getPhoneNumbersLoadingData = () => [
  {
    phoneNumber: <SkeletonLoading width={120} height={20} />,
    formattedRegion: <SkeletonLoading width={80} height={20} />,
    numberType: <SkeletonLoading width={60} height={20} />,
    addressRequirement: <SkeletonLoading width={100} height={20} />,
    pricePerQuarter: <SkeletonLoading width={60} height={20} />,
    action: <SkeletonLoading width={20} height={20} />,
    isLoading: true,
  },
  {
    phoneNumber: <SkeletonLoading width={110} height={20} />,
    formattedRegion: <SkeletonLoading width={70} height={20} />,
    numberType: <SkeletonLoading width={50} height={20} />,
    addressRequirement: <SkeletonLoading width={90} height={20} />,
    pricePerQuarter: <SkeletonLoading width={55} height={20} />,
    action: <SkeletonLoading width={20} height={20} />,
    isLoading: true,
  },
  {
    phoneNumber: <SkeletonLoading width={130} height={20} />,
    formattedRegion: <SkeletonLoading width={90} height={20} />,
    numberType: <SkeletonLoading width={70} height={20} />,
    addressRequirement: <SkeletonLoading width={110} height={20} />,
    pricePerQuarter: <SkeletonLoading width={65} height={20} />,
    action: <SkeletonLoading width={20} height={20} />,
    isLoading: true,
  },
  {
    phoneNumber: <SkeletonLoading width={100} height={20} />,
    formattedRegion: <SkeletonLoading width={75} height={20} />,
    numberType: <SkeletonLoading width={55} height={20} />,
    addressRequirement: <SkeletonLoading width={85} height={20} />,
    pricePerQuarter: <SkeletonLoading width={50} height={20} />,
    action: <SkeletonLoading width={20} height={20} />,
    isLoading: true,
  },
  {
    phoneNumber: <SkeletonLoading width={125} height={20} />,
    formattedRegion: <SkeletonLoading width={85} height={20} />,
    numberType: <SkeletonLoading width={65} height={20} />,
    addressRequirement: <SkeletonLoading width={105} height={20} />,
    pricePerQuarter: <SkeletonLoading width={70} height={20} />,
    action: <SkeletonLoading width={20} height={20} />,
    isLoading: true,
  },
];

